// Copyright (c) 2022 by Move Closer

import { Direction } from './Thumbnails.contrats'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl> (original)
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (edited)
 */
export const defaultCarouselConfig = (direction = Direction.Vertical, initialSlide = 0) => ({
  speed: 400,
  direction,
  initialSlide,
  perPage: 5,
  perScroll: 1
})
